import React, { useEffect, useState } from "react";
import moment from 'moment-jalaali'
import { Form, Select } from 'antd';
// import DatePicker from 'react-datepicker2'
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { useNavigate } from "react-router-dom";
import ValidatorHelper from "../helpers/ValidatorHelper";
import { usePersistedStore } from "../../store/persisted-store";
import { useNonePersistedStore } from "../../store/non-persisted-store";

export default function ReceiptsFilter(params) {
    const { business } = usePersistedStore();
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const { getReceipts, receipts } = useNonePersistedStore()
    const navigate = useNavigate();
    const loading = receipts.loading;
    const currentBusiness = business.currentBusiness;
    const { token } = currentBusiness;

    const receiptTypes = [{ Id: 0, Title: "همه" }, { Id: 1, Title: "عوارض بزرگراهی" }, { Id: 2, Title: "قسط" }, { Id: 3, Title: "شارژ کیف پول" }]

    useEffect(() => {
        if (!token)
            navigate('/dashboard');
    }, [navigate, token])

    function convertToMoment(date) {
        return moment(date?.toDate()).format("YYYY-MM-DD");
    }

    function onFinish(values) {
        getReceipts({
            fromDate: values.fromDate && convertToMoment(fromDate), //moment(values.fromDate).format("YYYY-MM-DD"),
            toDate: values.toDate && convertToMoment(toDate), //moment(values.toDate).format("YYYY-MM-DD"),
            type: values.type ? values.type : undefined
        });
    }

    return (
        <Form
            initialValues={{
                branch: params.branchId,
                user: "all",
                fromDate: params.fromDate && moment(params.fromDate).subtract(1, 'months'),
                toDate: params.toDate && moment(params.toDate)
            }}
            layout="inline" onFinish={onFinish}>
            <Form.Item
                rules={ValidatorHelper.required('نوع فاکتور')}
                name='type'
                label="نوع فاکتور:">
                <Select
                    style={{ minWidth: 200 }}>
                    {receiptTypes && receiptTypes.map((name, index) => {
                        return <Select.Option key={index} value={name.Id}>{name.Title}</Select.Option>
                    })}
                </Select>
            </Form.Item>
            <Form.Item
                rules={ValidatorHelper.required('تاریخ شروع')}
                name='fromDate'
                label='از تاریخ'>
                <DatePicker
                    value={fromDate}
                    onChange={setFromDate}
                    calendar={persian}
                    locale={persian_fa}
                    format="YYYY/MM/DD"
                    inputClass="datepicker-input"
                    calendarPosition="bottom-right"
                    portal
                    zIndex={1070}
                />
            </Form.Item>
            <Form.Item
                rules={ValidatorHelper.required('تاریخ پایان')}
                name='toDate'
                label='تا تاریخ'>
                <DatePicker
                    value={toDate}
                    onChange={setToDate}
                    calendar={persian}
                    locale={persian_fa}
                    format="YYYY/MM/DD"
                    inputClass="datepicker-input"
                    calendarPosition="bottom-right"
                    portal
                    zIndex={1070}
                />
            </Form.Item>
            <Form.Item label=" " colon={false}>
                <button
                    disabled={loading} type="primary"
                    className="btn btn-primary waves-effect waves-light" htmltype="submit">جستجو&nbsp;&nbsp;&nbsp;
                    <i className={loading ? "bx bx-loader bx-spin" : "fas fa-search"}></i>
                </button>
            </Form.Item>
        </Form>
    )
}